import React, { Component } from 'react';
import apiConfig from '../../api/apiConfig'
import {Link} from 'react-router-dom';
import './style.css';

class AddSubQuestion extends Component {
  constructor(props){
    super(props)

    this.queryString = window.location.href;

    if (this.queryString !== "") {
        this.catID = this.queryString.split("&c:")[1].split("/")[0]; 
        this.quesID = this.queryString.split("&q:")[1]; 
    }

    this.state={
        catID : this.catID,
        quesID : this.quesID,
        sec_sub_ques : "",
        order_no :"",
        questions:"",
        selectionType : "",
        validationMsg: {},
    }

    this.onChange = this.onChange.bind(this);
    this.onChangeOption = this.onChangeOption.bind(this);
    this.onChangeRadio = this.onChangeRadio.bind(this);
    this.saveData = this.saveData.bind(this);
  }

  componentWillMount(){

  }

  componentWillReceiveProps(nextProps){
     
    if(nextProps.demoGraphicsSubQuestionAddSuccess && nextProps.demoGraphicsSubQuestionSuccessmessage){
      alert(nextProps.demoGraphicsSubQuestionSuccessmessage);
      window.history.back();
      this.props.emptyDemoSubQuestionResponse();
    }else if(nextProps.demoGraphicsSubQuestionFailmessage){
      alert(nextProps.demoGraphicsSubQuestionFailmessage);
      this.props.emptyDemoSubQuestionResponse();
    }
   
  }

  onChange(e){
    this.setState({[e.target.name]: e.target.value});
  }

  onChangeOption(e){
    this.setState({[e.target.name]: e.target.value});
  }

  onChangeRadio(e){
    this.setState({[e.target.name]: e.target.value});
  }

  handleValidation() {
    
    let valid = true;
    let error = {};

    if (this.state.questions === "") {
        error.questions = "Can't leave empty";
        valid = false;
    }
    if(this.state.selectionType === ""){
        error.selectionType = "Can't leave unselect";
        valid = false;
    }

    if(this.state.sec_sub_ques === ""){
        error.sec_sub_ques = "Can't leave unselect";
        valid = false;
    }
   
    if (this.state.order_no === "") {
      error.order_no = "Please enter order_no";
      valid = false;
		}else if (!this.state.order_no.match(/^\d*$/)){
      error.order_no = "Please only enter numeric characters in order_no";
      valid = false;
    }
    this.setState({ validationMsg: error });
		return valid;
	}

  saveData(){
    let subQuesData = {};
      if (this.handleValidation()) {
        subQuesData.cat_id = this.state.catID;
        subQuesData.ques_id = this.state.quesID;
        subQuesData.orderSubQues = this.state.order_no;   
        subQuesData.questions = this.state.questions;
        subQuesData.selectionType = this.state.selectionType;  
        subQuesData.sec_sub_ques = this.state.sec_sub_ques;
        this.props.insertSubQuestion(subQuesData);  
    }
  }

  categoryList(){
    this.props.categoryList();
  }

  gotoBack(){
    window.history.back();
  }


  render() {

      let msg="";
      if(this.props.studyMessage){
        msg = this.props.studyMessage;
      }

      return (
        <div className = "regPage">
            <div className = "createnewstudy">
                <div className = "studyheader"><h1>Sub Question</h1></div>
            <div className = "setbackbutton">
            <br/>

            
            <button className = "editstudybackbtn" onClick={this.gotoBack}  >Back</button>
            
            <br/>
            <div className = "studypage">

            <div style={{ color: "red", textAlign:"center" }} >{this.state.validationMsg.selectionType}</div><br/><br/>

            <label id = "addQuesLabel">Do you want to add Sub question ? </label>
            
            <input type="radio" name="sec_sub_ques" value="true"  onChange={this.onChangeRadio} /> Yes
            <input style = {{marginLeft : "10%"}} type="radio" name="sec_sub_ques" value="false" onChange={this.onChangeRadio} /> No
            
            <div style={{ color: "red", textAlign:"center"}} >{this.state.validationMsg.sec_sub_ques}</div><br/><br/>

            <div>

            <label id = "lbl1">Question</label>
            <input type="text" className = "textFields" placeholder = "Enter question" name="questions" value={this.state.questions} onChange={this.onChange} />
            <div style={{ color: "red", textAlign:"center", marginTop: "-15px" }} >{this.state.validationMsg.questions}</div><br/>

            <label id = "lbl1">Order No</label>
            <input type="text" className = "textFields" placeholder = "Category Order" name="order_no" value={this.state.order_no} onChange={this.onChange} />
            <div style={{ color: "red", textAlign:"center", marginTop: "-15px" }} >{this.state.validationMsg.order_no}</div><br/><br/>
            
            <label id = "lbl1">Option type</label>
            <select  name="selectionType" className="selectOptionType" value={this.state.selectionType} onChange={this.onChangeOption}>
              <option value="">Select Option type</option>
              <option value="select">select</option>
              <option value="checkBox">checkBox</option>
            </select >

            
            <div className = "stdbtn"><button  className="studySavebtn" onClick={this.saveData}  >Create</button></div><br/>
            </div>
            <p className = "studyMSG">{msg}</p>
       </div>
       </div>
        </div>
        </div>
    );
  }
}
export default AddSubQuestion;


// WEBPACK FOOTER //
// ./src/components/demographics/addSubQuestion.js